var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevrondown({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -70.4590 87.6500 70.4590",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.8477-14.1602C44.9219-14.1602 45.9961-14.5508 46.7285-15.3809L76.709-45.5566C77.4414-46.2891 77.8809-47.2656 77.8809-48.3887C77.8809-50.6836 76.1719-52.4414 73.877-52.4414C72.8027-52.4414 71.7285-51.9531 70.9961-51.2695L41.5527-21.7285L46.0938-21.7285L16.6504-51.2695C15.918-51.9531 14.9414-52.4414 13.8184-52.4414C11.5234-52.4414 9.76562-50.6836 9.76562-48.3887C9.76562-47.2656 10.2051-46.2891 10.9375-45.5566L40.9668-15.3809C41.748-14.5508 42.7246-14.1602 43.8477-14.1602Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevrondown);
export default __webpack_public_path__ + "static/media/chevron.down.a0de979a72dd41ee456e41c7672996d6.svg";
export { ForwardRef as ReactComponent };